import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://api.flex-chat.net',
});

let onUnauthorized = () => {};

export const setUnauthorizedHandler = fn => {
  onUnauthorized = typeof fn === 'function' ? fn : () => {};
};

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export const setAuthHeader = token => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    api.defaults.headers.common.Authorization = '';
  }
};
